// src/pages/Home.js
import React from 'react';
import Header from '../components/Header';
import Carousel from '../components/Carousel';
import AboutUs from '../components/AboutUs';
import News from '../components/News';
import TicketSection from '../components/TicketSection';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

import '../pages/Home.css';
import hbg0 from '../background/hbg00.png';
import overlayImage from '../assets/ol1.png';

const Home = () => {
  return (
    <div className="page-container">
      <Header />

      <div className="top-bg-section" style={{ backgroundImage: `url(${hbg0})` }}>
        <div className="image-overlay-wrapper left-long">
          <img src={overlayImage} alt="Overlay" className="overlay-image tall-left" />
        </div>

        <div className="carousel-overlay-container">
          <Carousel />
        </div>
      </div>

      <div className="home-content">
        {/* Section IDs must match scroll map in App.js */}
        <section id="about-us">
          <AboutUs />
        </section>

        <section id="news-section">
          <News />
        </section>

        <div id="ticket-section">
          <TicketSection />
        </div>

        <section id="contact-us">
          <ContactUs />
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
